/* ============================================================
   GFY Coupon Offers — behavior (vanilla JS, no dependencies)
   Loaded once with defer. Idempotent: safe if included twice.
   ============================================================ */
(function () {
  'use strict';
  if (window.__gfyInit) return;
  window.__gfyInit = true;

  var SS = window.sessionStorage;
  var cfg = {};
  try {
    var cfgEl = document.getElementById('gfy-config');
    if (cfgEl) cfg = JSON.parse(cfgEl.textContent);
  } catch (e) { cfg = {}; }

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ============================================================
     MENU DRAWER: keep --header-bottom-position fresh at all times
     so the fixed drawer always anchors right below the sticky header.
  ============================================================ */
  (function () {
    function updateHeaderPos() {
      var header = document.querySelector('.section-header');
      if (!header) return;
      var bottom = Math.round(header.getBoundingClientRect().bottom);
      document.documentElement.style.setProperty('--header-bottom-position', bottom + 'px');
      document.documentElement.style.setProperty('--viewport-height', window.innerHeight + 'px');
    }
    updateHeaderPos();
    /* Scroll/resize updates are handled (rAF-throttled) by gehna-mobile-fix.js.
       Duplicate unthrottled listeners here caused a second forced layout on every
       scroll frame, so they were removed. The one-time call above still runs in
       case this script loads without gehna-mobile-fix.js. */
  })();

  /* ============================================================
     SCROLL LOCK — prevents background page scroll while the mobile
     menu drawer is open.

     Strategy: touch-action + overflow hidden on <html> only.
     We do NOT touch body position/top because the drawer is a
     descendant of the header and moving the body shifts the drawer
     content off-screen (the blank drawer bug).

     On iOS Safari, overflow:hidden on <html> alone is sufficient.
     We also block touchmove on the document (allowing it inside
     the drawer itself so the menu list stays scrollable).
  ============================================================ */
  (function () {
    var locked = false;
    var scrollY = 0;

    function preventScroll(e) {
      /* Allow scrolling inside the drawer */
      if (e.target.closest && e.target.closest('.menu-drawer')) return;
      e.preventDefault();
    }

    function lock() {
      if (locked) return;
      locked = true;
      scrollY = window.scrollY || window.pageYOffset;
      document.documentElement.style.overflow = 'hidden';
      document.addEventListener('touchmove', preventScroll, { passive: false });
    }

    function unlock() {
      if (!locked) return;
      locked = false;
      document.documentElement.style.overflow = '';
      document.removeEventListener('touchmove', preventScroll);
    }

    function attachObserver() {
      var drawerDetails = document.querySelector('header-drawer > details');
      if (!drawerDetails) return;
      new MutationObserver(function () {
        drawerDetails.hasAttribute('open') ? lock() : unlock();
      }).observe(drawerDetails, { attributes: true, attributeFilter: ['open'] });
      window.addEventListener('pageshow', function () {
        if (!drawerDetails.hasAttribute('open')) unlock();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', attachObserver);
    } else {
      attachObserver();
    }
  })();

  /* ---------------- Clipboard copy + confetti ---------------- */
  function confetti(x, y) {
    if (reduced) return;
    var colors = ['#C9A96E', '#B8964F', '#1A1A1A', '#FFFFFF', '#E7D9BC'];
    var root = document.createElement('div');
    root.className = 'gfy-confetti';
    root.style.left = x + 'px';
    root.style.top = y + 'px';
    for (var i = 0; i < 14; i++) {
      var p = document.createElement('i');
      p.style.background = colors[i % colors.length];
      p.style.setProperty('--dx', (Math.random() * 140 - 70) + 'px');
      p.style.setProperty('--dy', (40 + Math.random() * 80) + 'px');
      p.style.setProperty('--dr', (Math.random() * 540 - 270) + 'deg');
      root.appendChild(p);
    }
    document.body.appendChild(root);
    setTimeout(function () { root.remove(); }, 1100);
  }

  function fallbackCopy(text) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.cssText = 'position:fixed;left:-9999px;top:0';
    document.body.appendChild(ta);
    ta.select();
    try { document.execCommand('copy'); } catch (e) {}
    ta.remove();
  }

  function markCopied(btn) {
    var original = btn.dataset.gfyLabel || btn.textContent;
    btn.dataset.gfyLabel = original;
    btn.dataset.copied = 'true';
    btn.textContent = btn.dataset.gfyCopiedLabel || 'Copied!';
    btn.setAttribute('aria-live', 'polite');
    setTimeout(function () {
      btn.dataset.copied = 'false';
      btn.textContent = original;
    }, 2200);
  }

  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest('[data-gfy-copy]');
    if (!btn) return;
    var code = btn.getAttribute('data-gfy-copy');
    if (!code) return;
    var done = function () {
      markCopied(btn);
      try { SS.setItem('gfyCopied', code); } catch (e) {}
      var r = btn.getBoundingClientRect();
      confetti(r.left + r.width / 2, r.top);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done, function () { fallbackCopy(code); done(); });
    } else { fallbackCopy(code); done(); }
  });

  function restoreCopiedState(scope) {
    var code;
    try { code = SS.getItem('gfyCopied'); } catch (e) { return; }
    if (!code) return;
    (scope || document).querySelectorAll('[data-gfy-copy="' + code + '"]').forEach(function (b) {
      b.dataset.copied = 'true';
      b.textContent = b.dataset.gfyCopiedLabel || 'Copied!';
      setTimeout(function () { b.dataset.copied = 'false'; b.textContent = b.dataset.gfyLabel || 'Copy Code'; }, 2200);
    });
  }

  /* ---------------- Sticky bar rotation ---------------- */
  function initBar(bar) {
    var slides = bar.querySelectorAll('.gfy-bar__slide');
    if (slides.length < 2) { if (slides[0]) slides[0].classList.add('is-active'); return; }
    var idx = 0, speed = (parseInt(bar.dataset.speed, 10) || 4) * 1000, timer = null, paused = false;
    slides[0].classList.add('is-active');
    if (reduced) return;
    function next() {
      if (paused) return;
      slides[idx].classList.remove('is-active');
      idx = (idx + 1) % slides.length;
      slides[idx].classList.add('is-active');
    }
    function start() { stop(); timer = setInterval(next, speed); }
    function stop() { if (timer) clearInterval(timer); }
    bar.addEventListener('mouseenter', function () { paused = true; });
    bar.addEventListener('mouseleave', function () { paused = false; });
    bar.addEventListener('focusin', function () { paused = true; });
    bar.addEventListener('focusout', function () { paused = false; });
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
    start();
  }
  document.querySelectorAll('.gfy-bar[data-speed]').forEach(initBar);

  /* ---------------- Countdown timers ---------------- */
  document.querySelectorAll('[data-gfy-countdown]').forEach(function (el) {
    var end = new Date(el.getAttribute('data-gfy-countdown').replace(' ', 'T'));
    if (isNaN(end.getTime())) { el.hidden = true; return; }
    var d = el.querySelector('[data-d] b'), h = el.querySelector('[data-h] b'),
        m = el.querySelector('[data-m] b'), s = el.querySelector('[data-s] b');
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function tick() {
      var diff = end - Date.now();
      if (diff <= 0) { el.hidden = true; clearInterval(t); return; }
      var sec = Math.floor(diff / 1000);
      if (d) d.textContent = pad(Math.floor(sec / 86400));
      if (h) h.textContent = pad(Math.floor(sec / 3600) % 24);
      if (m) m.textContent = pad(Math.floor(sec / 60) % 60);
      if (s) s.textContent = pad(sec % 60);
    }
    var t = setInterval(tick, 1000); tick();
  });

  /* ---------------- Modal helper (FAB popup) ---------------- */
  var lastFocus = null;
  function openModal(m) {
    if (!m) return;
    lastFocus = document.activeElement;
    m.hidden = false;
    document.body.classList.add('overflow-hidden');
    var f = m.querySelector('.gfy-modal__close') || m;
    f.focus();
    restoreCopiedState(m);
  }
  function closeModal(m) {
    if (!m || m.hidden) return;
    m.hidden = true;
    document.body.classList.remove('overflow-hidden');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('click', function (ev) {
    var opener = ev.target.closest('[data-gfy-open]');
    if (opener) { openModal(document.getElementById(opener.getAttribute('data-gfy-open'))); return; }
    if (ev.target.closest('[data-gfy-close]') || ev.target.classList.contains('gfy-modal__overlay')) {
      closeModal(ev.target.closest('.gfy-modal'));
    }
  });
  document.addEventListener('keydown', function (ev) {
    if (ev.key !== 'Escape') return;
    document.querySelectorAll('.gfy-modal:not([hidden])').forEach(closeModal);
  });

  /* ---------------- Mobile bottom bar spacing ---------------- */
  (function () {
    var bar = document.querySelector('.gfy-mobilebar');
    if (!bar) return;
    function apply() {
      var mobile = window.matchMedia('(max-width: 749px)').matches;
      document.body.classList.toggle('gfy-has-mobilebar', mobile);
      document.documentElement.style.setProperty('--gfy-mobilebar-h', mobile ? bar.offsetHeight + 'px' : '0px');
    }
    apply();
    window.addEventListener('resize', apply, { passive: true });
  })();

  /* ---------------- Collection card badges ---------------- */
  (function () {
    if (!cfg.badgeEnabled || !cfg.pageCollection) return;
    var offers = (cfg.offers || []).filter(function (o) {
      return !o.collection || o.collection === cfg.pageCollection;
    });
    if (!offers.length) return;
    var tip = cfg.badgeTip || 'Use coupon for extra savings.';
    function decorate(scope) {
      (scope || document).querySelectorAll('.card-wrapper .card__inner').forEach(function (card) {
        if (card.querySelector('.gfy-badge')) return;
        var b = document.createElement('span');
        b.className = 'gfy-badge';
        b.textContent = cfg.badgeText || 'Offer Available';
        b.setAttribute('data-tip', tip);
        b.setAttribute('tabindex', '0');
        b.setAttribute('role', 'note');
        b.setAttribute('aria-label', (cfg.badgeText || 'Offer Available') + '. ' + tip);
        card.appendChild(b);
      });
    }
    var run = function () { decorate(document); };
    ('requestIdleCallback' in window) ? requestIdleCallback(run) : setTimeout(run, 200);
    var grid = document.getElementById('ProductGridContainer');
    if (grid && 'MutationObserver' in window) {
      new MutationObserver(function () { decorate(grid); }).observe(grid, { childList: true, subtree: true });
    }
  })();

  /* ---------------- Cart drawer: restore copied state ---------------- */
  var cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer && 'MutationObserver' in window) {
    new MutationObserver(function () { restoreCopiedState(cartDrawer); }).observe(cartDrawer, { childList: true, subtree: true });
  }

  restoreCopiedState(document);
})();
